import { useState, useEffect } from 'react';
import { transactions, answerOptions } from './data';
import TransactionsDecisions from '../../../thePrinciples/transactionsDecisions';
import { getAnimationClass } from './../utils';

export default function ExpenseRecognition({ onComplete }) {
  const [showP, setShowP] = useState(false);
  const [showLevel2Transactions, setShowLevel2Transactions] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;
    
    timeouts.push(setTimeout(() => setShowP(true), currentTime));
    
    currentTime += 7000;
    timeouts.push(setTimeout(() => setShowLevel2Transactions(true), currentTime));
    
    currentTime += 3500;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Principles</h1>
      
      <p className={getAnimationClass(showP)}>
        In this level, you'll practice your understanding of expense recognition principles by deciding if a transaction impacts profits. <b className="red">Pro tip</b>: Expense affects profits and is recognized when incurred, not when cash is paid.
      </p>

      {showLevel2Transactions && (
        <div className={`transition-transactions-decisions ${getAnimationClass(showLevel2Transactions)}`}>
          <TransactionsDecisions
            transactions={transactions}
            activeTransaction={0}
            answerOptions={answerOptions}
            isSubmitButtonShown={true}
          />
        </div>
      )}
    </>
  );
}